import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { PrimeReactProvider, addLocale, locale } from "primereact/api";
import { AppLayout } from "./components/layout/AppLayout";
import { FullPageLoading } from "./components/layout/FullPageLoading";
import { useAuth } from "./contexts/AuthContext";
import { useUser } from "./lib/api-client";
import { Login } from "./pages/Login";
import { EventsList } from "./pages/EventsList";
import { TagsList } from "./pages/TagsList";
import { EventCreate } from "./pages/EventCreate";
import { EventDetail } from "./pages/EventDetail";
import { EventEdit } from "./pages/EventEdit";
import { EventParticipants } from "./pages/EventParticipants";
import { CheckoutsList } from "./pages/CheckoutsList";
import { CheckoutDetail } from "./pages/CheckoutDetail";
import { PendingCheckouts } from "./pages/PendingCheckouts";
import { ParticipantDetail } from "./pages/ParticipantDetail";
import { UsersList } from "./pages/UsersList";
import { UserDetail } from "./pages/UserDetail";
import { GroupsList } from "./pages/GroupsList";
import { GroupDetail } from "./pages/GroupDetail";
import { PaymentsList } from "./pages/PaymentsList";

addLocale("en-GB", {
  firstDayOfWeek: 1, // Monday
  dateFormat: "dd/mm/yy",
});
locale("en-GB");

function ProtectedLayout() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();
  const { data: user, isLoading: isUserLoading } = useUser();

  if (isAuthLoading || (isAuthenticated && isUserLoading)) {
    return <FullPageLoading />;
  }

  if (!isAuthenticated || !user?.isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

function App() {
  return (
    <PrimeReactProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<EventsList />} />
          <Route path="/events" element={<EventsList />} />
          <Route path="/tags" element={<TagsList />} />
          <Route path="/groups" element={<GroupsList />} />
          <Route path="/groups/:id" element={<GroupDetail />} />
          <Route path="/events/new" element={<EventCreate />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/events/:id/edit" element={<EventEdit />} />
          <Route path="/events/:id/participants" element={<EventParticipants />} />
          <Route path="/checkouts" element={<CheckoutsList />} />
          <Route path="/checkouts/pending" element={<PendingCheckouts />} />
          <Route path="/checkouts/:id" element={<CheckoutDetail />} />
          <Route path="/participants/:id" element={<ParticipantDetail />} />
          <Route path="/payments" element={<PaymentsList />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/:id" element={<UserDetail />} />
        </Route>
      </Routes>
    </PrimeReactProvider>
  );
}

export default App;
